import { Controller } from 'react-hook-form';
import { Checkbox, ButtonSecondary, ButtonSize } from '@ui/src';
import { OTPFormTypes } from './types';
import { PSPOTPType } from '../../../hoc/settings/types';

import cn from './styles.module.css';

const OTPForm = ({
  control,
  onSubmit,
  children,
  fields,
  setValue,
}: OTPFormTypes): React.JSX.Element => (
  <form onSubmit={onSubmit} className={`${cn.details} ${cn.otpDetails}`}>
    <div className={cn.brandColorsTitle}>Customers</div>
    <div className={cn.otpSettingsDescription}>
      Configure the available confirmation methods for each category of
      operations
    </div>
    <div className={cn.otpDetailsFormContent}>
      <div className={cn.otpDetailsFormContentTitle}>
        Authorization confirmation
      </div>
      <div className={cn.otpDetailsFormContentValues}>
        <Controller
          control={control}
          name="otpAuthAvailableMethods"
          render={({ field: { onChange, value, name } }) => (
            <>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`auth-${name}-sms`}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.SMS),
                  )}
                  labelClassName={cn.valueItem}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.SMS)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.SMS,
                      );
                    } else {
                      nextValues.push(PSPOTPType.SMS);
                    }

                    onChange(nextValues);
                  }}
                  title="SMS"
                />
                {fields?.otpAuthDefaultMethod === PSPOTPType.SMS && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpAuthDefaultMethod !== PSPOTPType.SMS && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue('otpAuthDefaultMethod', PSPOTPType.SMS)
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`auth-${name}-whatsapp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.WHATSAPP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (
                      nextValues?.find((item) => item === PSPOTPType.WHATSAPP)
                    ) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.WHATSAPP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.WHATSAPP);
                    }

                    onChange(nextValues);
                  }}
                  title="Whatsapp"
                />
                {fields?.otpAuthDefaultMethod === PSPOTPType.WHATSAPP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpAuthDefaultMethod !== PSPOTPType.WHATSAPP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue('otpAuthDefaultMethod', PSPOTPType.WHATSAPP)
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`auth-${name}-totp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.TOTP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.TOTP)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.TOTP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.TOTP);
                    }

                    onChange(nextValues);
                  }}
                  title="Authenticator app (TOTP)"
                />
                {fields?.otpAuthDefaultMethod === PSPOTPType.TOTP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpAuthDefaultMethod !== PSPOTPType.TOTP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue('otpAuthDefaultMethod', PSPOTPType.TOTP)
                    }
                  />
                )}
              </div>
            </>
          )}
        />
      </div>
    </div>
    <div className={cn.otpDetailsFormContent}>
      <div className={cn.otpDetailsFormContentTitle}>
        Transaction confirmation
      </div>
      <div className={cn.otpDetailsFormContentValues}>
        <Controller
          control={control}
          name="otpTransactionSignAvailableMethods"
          render={({ field: { onChange, value, name } }) => (
            <>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`transactions-${name}-sms`}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.SMS),
                  )}
                  labelClassName={cn.valueItem}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.SMS)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.SMS,
                      );
                    } else {
                      nextValues.push(PSPOTPType.SMS);
                    }

                    onChange(nextValues);
                  }}
                  title="SMS"
                />
                {fields?.otpTransactionSignDefaultMethod === PSPOTPType.SMS && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpTransactionSignDefaultMethod !== PSPOTPType.SMS && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpTransactionSignDefaultMethod',
                        PSPOTPType.SMS,
                      )
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`transactions-${name}-whatsapp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.WHATSAPP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (
                      nextValues?.find((item) => item === PSPOTPType.WHATSAPP)
                    ) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.WHATSAPP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.WHATSAPP);
                    }

                    onChange(nextValues);
                  }}
                  title="Whatsapp"
                />
                {fields?.otpTransactionSignDefaultMethod ===
                  PSPOTPType.WHATSAPP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpTransactionSignDefaultMethod !==
                  PSPOTPType.WHATSAPP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpTransactionSignDefaultMethod',
                        PSPOTPType.WHATSAPP,
                      )
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`transactions-${name}-totp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.TOTP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.TOTP)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.TOTP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.TOTP);
                    }

                    onChange(nextValues);
                  }}
                  title="Authenticator app (TOTP)"
                />
                {fields?.otpTransactionSignDefaultMethod ===
                  PSPOTPType.TOTP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpTransactionSignDefaultMethod !==
                  PSPOTPType.TOTP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpTransactionSignDefaultMethod',
                        PSPOTPType.TOTP,
                      )
                    }
                  />
                )}
              </div>
            </>
          )}
        />
      </div>
    </div>
    <div className={cn.otpDetailsFormContent}>
      <div className={cn.otpDetailsFormContentTitle}>
        Applications confirmation
      </div>
      <div className={cn.otpDetailsFormContentValues}>
        <Controller
          control={control}
          name="otpApplicationSignAvailableMethods"
          render={({ field: { onChange, value, name } }) => (
            <>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`applications-${name}-sms`}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.SMS),
                  )}
                  labelClassName={cn.valueItem}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.SMS)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.SMS,
                      );
                    } else {
                      nextValues.push(PSPOTPType.SMS);
                    }

                    onChange(nextValues);
                  }}
                  title="SMS"
                />
                {fields?.otpApplicationSignDefaultMethod === PSPOTPType.SMS && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpApplicationSignDefaultMethod !== PSPOTPType.SMS && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpApplicationSignDefaultMethod',
                        PSPOTPType.SMS,
                      )
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`applications-${name}-whatsapp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.WHATSAPP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (
                      nextValues?.find((item) => item === PSPOTPType.WHATSAPP)
                    ) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.WHATSAPP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.WHATSAPP);
                    }

                    onChange(nextValues);
                  }}
                  title="Whatsapp"
                />
                {fields?.otpApplicationSignDefaultMethod ===
                  PSPOTPType.WHATSAPP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpApplicationSignDefaultMethod !==
                  PSPOTPType.WHATSAPP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpApplicationSignDefaultMethod',
                        PSPOTPType.WHATSAPP,
                      )
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`applications-${name}-totp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.TOTP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.TOTP)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.TOTP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.TOTP);
                    }

                    onChange(nextValues);
                  }}
                  title="Authenticator app (TOTP)"
                />
                {fields?.otpApplicationSignDefaultMethod ===
                  PSPOTPType.TOTP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpApplicationSignDefaultMethod !==
                  PSPOTPType.TOTP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpApplicationSignDefaultMethod',
                        PSPOTPType.TOTP,
                      )
                    }
                  />
                )}
              </div>
            </>
          )}
        />
      </div>
    </div>
    <div className={cn.otpDetailsFormContent}>
      <div className={cn.otpDetailsFormContentTitle}>
        Agreements confirmation
      </div>
      <div className={cn.otpDetailsFormContentValues}>
        <Controller
          control={control}
          name="otpAgreementSignAvailableMethods"
          render={({ field: { onChange, value, name } }) => (
            <>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`agreements-${name}-sms`}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.SMS),
                  )}
                  labelClassName={cn.valueItem}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.SMS)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.SMS,
                      );
                    } else {
                      nextValues.push(PSPOTPType.SMS);
                    }

                    onChange(nextValues);
                  }}
                  title="SMS"
                />
                {fields?.otpAgreementSignDefaultMethod === PSPOTPType.SMS && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpAgreementSignDefaultMethod !== PSPOTPType.SMS && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue('otpAgreementSignDefaultMethod', PSPOTPType.SMS)
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`agreements-${name}-whatsapp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.WHATSAPP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (
                      nextValues?.find((item) => item === PSPOTPType.WHATSAPP)
                    ) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.WHATSAPP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.WHATSAPP);
                    }

                    onChange(nextValues);
                  }}
                  title="Whatsapp"
                />
                {fields?.otpAgreementSignDefaultMethod ===
                  PSPOTPType.WHATSAPP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpAgreementSignDefaultMethod !==
                  PSPOTPType.WHATSAPP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue(
                        'otpAgreementSignDefaultMethod',
                        PSPOTPType.WHATSAPP,
                      )
                    }
                  />
                )}
              </div>
              <div className={cn.otpDetailsFormContentValueItem}>
                <Checkbox
                  type="checkbox"
                  name={`agreements-${name}-totp`}
                  labelClassName={cn.valueItem}
                  checked={Boolean(
                    value?.find((item) => item === PSPOTPType.TOTP),
                  )}
                  onChange={() => {
                    let nextValues = ([] as string[]).concat(value as string[]);

                    if (nextValues?.find((item) => item === PSPOTPType.TOTP)) {
                      nextValues = nextValues?.filter(
                        (item) => item !== PSPOTPType.TOTP,
                      );
                    } else {
                      nextValues.push(PSPOTPType.TOTP);
                    }

                    onChange(nextValues);
                  }}
                  title="Authenticator app (TOTP)"
                />
                {fields?.otpAgreementSignDefaultMethod === PSPOTPType.TOTP && (
                  <span className={cn.defaultValue}>Default</span>
                )}
                {fields?.otpAgreementSignDefaultMethod !== PSPOTPType.TOTP && (
                  <ButtonSecondary
                    className={`${cn.setDefaultButton} button-white`}
                    size={ButtonSize.SMALL}
                    text="Set at default"
                    onClick={() =>
                      setValue('otpAgreementSignDefaultMethod', PSPOTPType.TOTP)
                    }
                  />
                )}
              </div>
            </>
          )}
        />
      </div>
    </div>
    {children}
  </form>
);

export default OTPForm;
